import prototype from "../../../../docs/prototypes/employees-full-flow.html?raw";
import "./staff.css";
import "./staff-deductions.css";
import overviewCss from "./staff-overview.css?raw";
import "./staff-step10.css";
import idCardCss from "./staff-id-card-photos.css?raw";
import "./staff-step11.css";
import "./staff-position-pay.css";

// The approved stylesheet is the visual authority. Scope it so unrelated
// Uniforms/cash screens cannot inherit any of the prototype's selectors.
// Uploaded HTML has a small browser-reset <style> before the approved stylesheet.
// Read the actual stylesheet (not the reset, nor style strings inside scripts).
const css = (prototype.split("<script>")[0].match(/<style>\s*\/\* Layout:[\s\S]*?<\/style>/)?.[0].replace(/^<style>|<\/style>$/g, "") || prototype.match(/<style>([\s\S]*?)<\/style>/)?.[1] || "")
  // Prototype modals are siblings. React's nested dialogs must not inherit the
  // employee card's zero-padding / 1100px container rules.
  .replace(/#empOv \.md/g, "#empOv > .md")
  .replace(/:root/g, ":scope")
  .replace(/html\.ar/g, ':scope[lang="ar"]')
  .replace(/\.ar body\s*\{/g, ':scope[lang="ar"]{')
  .replace(/\bbody\s*\{/g, ":scope{")
  .replace(/\.ar /g, ':scope[lang="ar"] ')
  .replace(/\[dir=rtl\]/g, ":scope[dir=rtl]")
  .replace(/\[lang=ar\]/g, ':scope[lang="ar"]');

export default function StaffStyles() {
  return <>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=IBM+Plex+Sans+Arabic:wght@400;500;600;700&family=JetBrains+Mono:wght@500;700&display=swap" />
    <style data-infrastock-staff-scope>{`@scope (.staff-ui) { ${css} }`}</style>
    <style>{overviewCss}</style>
    <style>{idCardCss}</style>
  </>;
}
